export default __webpack_public_path__ + "static/media/ic-practice-quiz.b7cad17e.svg";